import React from 'react';
import './PartnerDetailsModal.css';

const PartnerDetailsModal = ({ isOpen, onClose, partner, connectorName }) => {
    if (!isOpen || !partner) return null;

    return (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="partner-details-modal">
                <div className="modal-header">
                    <h2>Partner Details</h2>
                    <button className="modal-close" onClick={onClose}>
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>

                <div className="modal-body">
                    {/* Basic Info Section */}
                    <div className="form-section">
                        <div className="section-header">
                            <span className="section-icon">📋</span>
                            <span>Basic Information</span>
                        </div>
                        <div className="details-grid">
                            <div className="detail-item">
                                <span className="label">Name</span>
                                <span className="value">{partner.name}</span>
                            </div>
                            <div className="detail-item">
                                <span className="label">Type</span>
                                <span className="value">{partner.partnerType || 'Trading Partner'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="label">Status</span>
                                <span className={`status-badge ${partner.isActive ? 'active' : 'inactive'}`}>
                                    {partner.isActive ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Identifiers Section */}
                    <div className="form-section">
                        <div className="section-header">
                            <span className="section-icon">🔢</span>
                            <span>Identifiers</span>
                        </div>
                        <div className="details-grid">
                            <div className="detail-item">
                                <span className="label">GLN</span>
                                <span className="value monospace">{partner.gln || 'N/A'}</span>
                            </div>
                            {partner.sgln && (
                                <div className="detail-item">
                                    <span className="label">SGLN</span>
                                    <span className="value monospace">{partner.sgln}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Contact Section */}
                    <div className="form-section">
                        <div className="section-header">
                            <span className="section-icon">📧</span>
                            <span>Contact Information</span>
                        </div>
                        <div className="details-grid">
                            <div className="detail-item">
                                <span className="label">Email</span>
                                <span className="value">{partner.email || '—'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="label">Phone</span>
                                <span className="value">{partner.phone || '—'}</span>
                            </div>
                            <div className="detail-item full-width">
                                <span className="label">Address</span>
                                <span className="value">{partner.address || '—'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Connection Section */}
                    <div className="form-section">
                        <div className="section-header">
                            <span className="section-icon">🔌</span>
                            <span>Connection Settings</span>
                        </div>
                        <div className="details-grid">
                            <div className="detail-item">
                                <span className="label">AS2 Connector</span>
                                <span className="value">{connectorName || 'Not Configured'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="label">Invitation Status</span>
                                <span className={`invitation-badge ${partner.invitationStatus || 'not_sent'}`}>
                                    {partner.invitationStatus === 'accepted' ? '✓ Accepted' :
                                        partner.invitationStatus === 'pending' ? '⏳ Pending' : '○ Not Sent'}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Activity Section */}
                    <div className="form-section">
                        <div className="section-header">
                            <span className="section-icon">📊</span>
                            <span>Activity</span>
                        </div>
                        <div className="details-grid">
                            <div className="detail-item">
                                <span className="label">Total Shipments</span>
                                <span className="value">{partner.shipmentCount || 0}</span>
                            </div>
                            <div className="detail-item">
                                <span className="label">Last Activity</span>
                                <span className="value">
                                    {partner.lastShipmentDate ? new Date(partner.lastShipmentDate).toLocaleString() : 'Never'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="btn-close" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default PartnerDetailsModal;
